import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ISession {
  singleItemAccessToken?: string;
  singleTaskAccessToken?: string;
}

const initialState: ISession = {
  singleItemAccessToken: undefined,
  singleTaskAccessToken: undefined,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState: initialState,
  reducers: {
    setSingleItemAccessToken: (state, action: PayloadAction<string>) => {
      state.singleItemAccessToken = action.payload;
    },
    setSingleTaskAccessToken: (state, action: PayloadAction<string>) => {
      state.singleTaskAccessToken = action.payload;
    },
  },
});

export const { setSingleItemAccessToken, setSingleTaskAccessToken } =
  sessionSlice.actions;

export default sessionSlice.reducer;
